import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc MemberDetailsAlertsStatsWidget defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberDetailsAlertsStatsWidgetService } from 'services/memberDetailsAlertsStatsWidget';
 *
 * // create service instance and send/cancel request
 * const memberDetailsAlertsStatsWidgetService = new MemberDetailsAlertsStatsWidgetService();
 * const result = await memberDetailsAlertsStatsWidgetService.fetchData( '<user-id>' ); // fetch data
 * memberDetailsAlertsStatsWidgetService.cancel(); // cancel an active request
 */
export class MemberDetailsAlertsStatsWidgetService extends HttpService {

    // make request and fetch component data
    async fetchComponentData( { url = {}, data = {} } = {} ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    title: get( response, 'body.component.structure.title', {} ),
                    alertTypes: get( response, 'body.component.structure.alertTypes', [] ),
                    values: get( response, 'body.component.data.state', {} )
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
